// @flow

import { combineReducers } from 'redux-immutable';

import lista from './lista';

export default combineReducers({ lista });